/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Checkbox } from '@mui/material'
import React from 'react'

function MUICheckbox(props: any):JSX.Element {
  return (
    <Checkbox disableRipple {...props} size='small' icon={<img src="/assets/images/icons/CheckBoxPlain.svg" alt='' width={16} height={16} />} checkedIcon={<img src="/assets/images/checkbox.svg" alt='' width={16} height={16} />} indeterminateIcon={<img src="/assets/images/minus.svg" alt='' width={16} height={16} />} />
  )
}

export default MUICheckbox